<template>
    <div class="Feedback">
        <Menu :sesion="sesion" :url="url" v-if="sesion"/>
        <Submenu :menuActivo="0" :url="url"/>

        <!--Spinner-->
        <div class="d-flex justify-content-center mt-5" v-if="status == false">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>

        <!-- Main content -->
        <div v-else>
            <div class="pt-2">
                <div class="container-fluid">
                    <div class="card" v-for="f in userInfo" :key="f.index">
                        <div class="row pt-3">
                            <div class="col-sm-2">
                                <p class="pl-3">
                                <img class="img-circle img" :src="getUrl(f.avatar)" 
                                style="height:150px !important; width: 135px; border-radius: 15px;"></p>
                            </div>
                            <div class="col-sm-4">
                                <p>
                                    @{{f.usuario}}
                                    <img :src="getBandera(f.pais_region)" class="flag">
                                </p>
                                <star-rating :increment="0.1" :rating="makeNumber(f.estrellas)" :star-size="35" :read-only="true"/>
                                <p class="pt-3">
                                    <b v-if="rol == 0">Consultor:</b>
                                    <b v-if="rol == 1">Empresa:</b>
                                    
                                    <span v-if="f.verificado == 1" class="badge badge-success">Verificado</span>
                                    <span v-else class="badge badge-danger">No Verificado</span>
                                </p>
                                <div v-if="rol==0">
                                    <p style="margin: 2px" v-for="f in especialidades" :key="f.id_modulo">
                                        <span  class="badge badge-success">
                                            {{f.module_cod}} - {{f.module_name}}
                                        </span>
                                    </p>
                                </div>
                                <div v-else>
                                    <p>{{industria}}</p>
                                </div>
                            </div>
                            <div class="col-sm-6 pr-4">
                                <Sobremi v-if="rol == '0'" :nota = "f.notas"></Sobremi>
                                <Estadisticas v-else :idUsr = "id_user" :rol = "rol"/>
                            </div>
                        </div>

                        <div class="pl-4 pr-4" v-if="rol =='0' ">
                            <hr>
                        </div>
                        
                        <div class="row pt-3">
                            <div class="col-sm-6 pl-4">
                                <Estadisticas v-if="rol == '0'" :idUsr = "id_user" :rol = "rol"/>
                            </div>
                            <div class="col-sm-6 pl-4">
                                <Certificaciones v-if="rol == '0'" 
                                :cert1 = "f.certificacion_a_1" 
                                :cert2 = "f.certificacion_a_2" 
                                :cert3 = "f.certificacion_a_3"
                                :cert1_val = "f.certificacion_val1"
                                :cert2_val = "f.certificacion_val2"
                                :cert3_val = "f.certificacion_val3" 
                                :cert_nom1 = "f.cert_nombre1"
                                :cert_nom2 = "f.cert_nombre2"
                                :cert_nom3 = "f.cert_nombre3"/>
                            </div>
                        </div>
                        <br>
                    </div>
                </div>
            </div>
        
            <div class="container-fluid" v-if="feedback == null">
                <div class="pt-3">
                    <p class="text-center">Sin reseñas</p>
                </div>
            </div>

            <div class="container-fluid" v-else >
                <h2 class="pt-4">Reseñas: </h2>
                <Resenas  :comentarios = "feedback" :rol = "rol"/>
            </div>
        </div>
        
    </div>
</template>


<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'

import Submenu from '@/components/Submenu'
import Menu from '@/components/Menu'
import StarRating from 'vue-star-rating'
import Sobremi from '@/components/Sobremi'
import Certificaciones from '@/components/Certificaciones'
import Estadisticas from '@/components/Estadisticas'
import Resenas from '@/components/Resenas'

export default {
name:'Feedback',
mixins: [ globalFunctions ],
components:{ Submenu,StarRating,Menu,Sobremi,Certificaciones, Estadisticas, Resenas},
data(){
    return{
        rating:2,
        feedback: [],
        sesion: false,
        userInfo:[],
        status: false,
        rol: 0,
        proyectos: '',
        ingresos: 0,
        efect: '',
        id_user: this.$route.params.id,
        especialidades: [],
        industria: '',
    }
},
methods:{
    getData(){

        let data = {
            flag: 0,
            id: this.id_user,
            rol: 0
        }

        this.axios.post(this.url + 'consultar.php', data).then((responce) =>{
            //console.log(responce);
            this.userInfo = responce.data;
            this.industria = responce.data[0].industria;
            this.rol = responce.data[0].rol;
            this.status = true;

            let data2 = {
                flag: 8,
                id1: responce.data[0].especializacion1,
                id2: responce.data[0].especializacion2,
                id3: responce.data[0].especializacion3
            };

            this.axios.post(this.url + 'consultasBasicas.php', data2).then((responce) =>{
                this.especialidades = responce.data;
                //console.log(this.especialidades);
            })

            this.getResenas(this.rol,data);
        })

        this.axios.post(this.url + 'getEstadisticas.php', data).then((responce) =>{
            //console.log(responce);
            this.proyectos = responce.data.cantidad;
            this.ingresos = responce.data.total;
            this.efect = responce.data.efect;
        })

        
    },

    getResenas(rol, data){

        if (rol == "0"){
            data.rol = 1 //Consultor
        }else {
            data.rol = 0 //Empresa
        }

        this.axios.post(this.url + 'getFeedback.php', data).then((responce) =>{
            //console.log(responce);
            this.feedback = responce.data;
        })
    }
},

 watch: {
    "$route.params.id": {
      handler: function(value) {
        //console.log(value);
        this.id_user = value;
        this.getData();
      },
      deep: true,
      immediate: true,
    },
  },

computed:{
    ...mapState(['url'])
},

mounted(){
    //this.getData();

    //check
    let resp = this.checkUser();
    this.sesion = resp;
}

}
</script>


<style scoped>

.card-header{
    background-color: white;
}

.card-footer{
    background-color: white;
}

.img {
    width: 45px;
}

.flag{
    width: 35px;
    height: 20px;
}

</style>


// WEBPACK FOOTER //
// src/views/Calificacion/Calificacion.vue